import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TranslateService } from '@app/core/services/translate.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { EconomyService, SalaryTypeItem } from '@app/services/economy.service';
import { ShiftDayTimeGet, ShiftDayTimeParams, ShiftService } from '@app/services/shift.service';

@Component({
  selector: 'tt-shift-day-time',
  templateUrl: './shift-day-time.component.html',
  styleUrls: ['./shift-day-time.component.css'],
  standalone: false,
})
export class ShiftDayTimeComponent implements OnInit {
    public page?: ShiftDayTimeGet;
    public salaryTypes: SalaryTypeItem[] = [];
    public params: ShiftDayTimeParams = { shift_id: '', dayno: '', shifttime_keyno: '0' };
    public saving = false;
    public deleting = false;

    constructor(
        private readonly shift: ShiftService,
        private readonly economy: EconomyService,
        private readonly modal: ModalService,
        private readonly translate: TranslateService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.params = { shift_id: String(this.navigator?.params['shift_id'] ?? ''), dayno: String(this.navigator?.params['dayno'] ?? ''), shifttime_keyno: String(this.navigator?.params['shifttime_keyno'] ?? '0') };
        const [page, weekDays, salaryTypes] = await Promise.all([this.shift.getDayTime(this.params), this.shift.getWeekDays({ shift_id: this.params.shift_id }), this.economy.getSalaryTypes()]);
        page.day_name = weekDays.find(day => String(day.item_id) === this.params.dayno)?.item_name ?? '';
        this.page = page;
        this.salaryTypes = salaryTypes;
    }

    public onTimeChanged(value: string, field: 'in_time' | 'out_time'): void {
        if (!this.page || this.page[field] === value) return;
        this.page[field] = value;
        if (!value.trim()) return;
        if (field === 'in_time') {
            this.page.in_from_time = value;
            this.page.in_to_time = value;
        } else {
            this.page.out_from_time = value;
            this.page.out_to_time = value;
        }
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving || this.deleting) return;
        this.saving = true;
        try {
            await this.shift.saveDayTime({ ...this.page, shift_id: this.params.shift_id, dayno: this.params.dayno });
            await this.navigator?.back();
        } finally { this.saving = false; }
    }

    public async deleteValues(): Promise<void> {
        if (!this.page || this.deleting || this.saving) return;
        this.deleting = true;
        try {
            if (!await this.modal.openConfirmDialog({ type: 'danger', title: 'confirm_title', translateTitle: true, message: 'confirm_message', translateMessage: true, ok: 'confirm_ok_label', cancel: 'confirm_cancel_label' })) return;
            const response = await this.shift.deleteDayTime({ shifttime_keyno: this.page.shifttime_keyno });
            if (String(response.status_no) !== '0') {
                await this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response.status_message, buttons: [{ label: await this.translate.translate('ok'), cssClass: 'btn-warning', close: true }] });
            } else { await this.navigator?.back(); }
        } finally { this.deleting = false; }
    }
}
